import { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useRouter } from 'next/router';
import { UiButton } from 'znanie-uikit';

import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import MasonryGrid from 'components/common/Masonry';

import EventPreview from 'components/event/EventPreview';

import { EventType, BroadcastType } from 'graphql/types';

import { masonryBreakpointCols } from 'utils/constants';

import css from './EventsList.module.scss';

interface IProps {
  mode?: 'infinite' | 'more_btn';
  onPage?: number;
  events: EventType[];
  hasMore?: boolean;
  customBreakpoints?: any;
  onLoadMore?(): void;
}

const sizesMap: any = [
  'normal',
  'large',
  'small',
  'small',
  'small',
  'normal',
  'large',
  'normal',
  'small',
  'small',
];

export default function EventsList({
  mode = 'infinite',
  onPage = 3,
  events = [],
  customBreakpoints,
  hasMore,
  onLoadMore,
}: IProps) {
  const [count, setCount] = useState(onPage);
  const [list, setList] = useState(events.slice(0, onPage));
  const [isMoreClicked, setIsMoreClicked] = useState(false);
  const [mobile, setMobile] = useState(false);
  const { isMobile } = useMediaQueries();

  const router = useRouter();

  let sizeIndex = 0;

  const handleMoreBtnClick = () => {
    if (!isMoreClicked) {
      setCount((items) => items + onPage);
      setIsMoreClicked(true);
    } else {
      router.push('/events');
    }
  };

  const handleLoadMore = () => {
    if (onLoadMore) {
      onLoadMore();
    }
  };

  useEffect(() => {
    setMobile(isMobile);
  }, []);

  useEffect(() => {
    setList(events.slice(0, count));
  }, [count, events]);

  const showEventsGrid = (data: EventType[]) =>
    data.map(
      (
        {
          slug,
          coverUrl,
          mobileImageUrl,
          name,
          startDate,
          finishDate,
          enrollFinishDate,
          venue,
          placesLeft,
          isOffline,
          offRegistration,
          broadcasts,
        },
        index
      ) => {
        if (index % sizesMap.length === 0) {
          sizeIndex = 0;
        } else {
          sizeIndex++;
        }

        return (
          <EventPreview
            key={index}
            link={`/events/${slug}`}
            background={mobileImageUrl || coverUrl || ''}
            title={name || ''}
            dateStart={startDate}
            dateEnd={finishDate}
            enrollFinishDate={enrollFinishDate}
            isOffline={Boolean(isOffline)}
            isRegistrationOff={Boolean(offRegistration)}
            city={venue?.address?.city || ''}
            heightSize={mobile ? 'small' : sizesMap[sizeIndex]}
            seats={placesLeft || 0}
            capacity={venue?.capacity || 0}
            broadcasts={(broadcasts as BroadcastType[]) || []}
          />
        );
      }
    );

  return (
    <div className={css.container}>
      {mode === 'infinite' ? (
        <InfiniteScroll
          loadMore={handleLoadMore}
          hasMore={hasMore}
          threshold={100}
        >
          <MasonryGrid
            breakpointColumns={customBreakpoints || masonryBreakpointCols}
          >
            {showEventsGrid(events)}
          </MasonryGrid>
        </InfiniteScroll>
      ) : (
        <>
          <MasonryGrid
            breakpointColumns={customBreakpoints || masonryBreakpointCols}
          >
            {showEventsGrid(list)}
          </MasonryGrid>
          {events.length > list.length && (
            <UiButton
              className={css.button}
              variant="secondary"
              onClick={handleMoreBtnClick}
            >
              Показать больше
            </UiButton>
          )}
        </>
      )}
    </div>
  );
}
